export default {"src":"/_next/static/media/insuranceLogo2.0684d537.svg","height":64,"width":127,"blurWidth":0,"blurHeight":0};